module.exports = __webpack_public_path__ + "static/media/vine-social-media-svgrepo-com (1).7514fb3b.svg";